@if (label && label.key) {
  <div>
    <label>{{label.key | translate}}</label>
  </div>
}
@if (fileList) {
  <div class="img-area">
    @if (isPreviewVisible && previewLoaded) {
      <div>
        <span class="remove" (click)="clearSelection()" [attr.id]="label && label.key ? (label.key | translate) + 'RemoveFile' : 'removeFile'">
          <span class="sap-icon">&#xe03e;</span>
        </span>
        <img #img id="img" [src]="filePath" (alt)="value" [attr.title]="'Admin.DownloadImage' | translate" (click)="download()">
      </div>
    }
    @if (!previewLoaded) {
      <div class="upload">
        @if (!value) {
          <span  class="sap-icon">&#xe219;</span>
        }
        @if (!value) {
          <div>
            <a class="file-browse" href="javascript:void(0)">
              {{(multiple ? 'Msg.UploadFiles' : 'Msg.UploadNewFile') | translate}}
              <input type="file" name="file" (change)="onFileSelected($event)" [attr.id]="label && label.key ? (label.key | translate) + 'UploadFile' : 'uploadFile'" class="file-upload-btn" [accept]="accept" [multiple]="multiple">
            </a>
            @if (type === FileInputType.SELECT) {
              <div>
                {{'Msg.OrSelectFromExisting' | translate}}
              </div>
            }
            {{ allowedExtensionsInfo }}
          </div>
        }
        @if (value) {
          <div>
            <a class="file-browse" (click)="download()">{{value}}</a>
            <span>|</span>
            <a class="file-browse" (click)="remove()">{{'Admin.Msg.RemoveButton' | translate}}</a>
            @if (showDelete) {
              <div>
                <span>|</span>
                <a class="file-browse" (click)="delete()">{{'xsltDelete' | translate}}</a>
              </div>
            }
          </div>
        }
        @if (!value) {
          <div  class="select-existing">
            @switch (type) {
              @case (FileInputType.SIMPLE) {
                <label class="file-name">{{value ? value : 'Admin.Msg.NoFileSelected' | translate}}</label>
              }
              @case (FileInputType.SELECT) {
                <div>
                  <cpq-select [(ngModel)]='value' (change)="preview()" (onChange)="change()" [type]='SelectType.Searchable' [items]='fileList' [label]="{key: '', placeholder: 'Msg.SelectFile'}" [id]="label && label.key ? (label.key | translate) + 'SelectFile' : 'selectFile'">
                  </cpq-select>
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
}
